import { Box, Checkbox, Stack, Tooltip, Typography } from '@mui/material'
import ColoredMultySelect, {
  TValues,
} from 'components/ui/ColoredMultySelect/ColoredMultySelect'
import { FILTERS_MODE } from '../DataAnalysisFilters'
import { TBlend } from 'types'
import { generateStaticColor } from '../../../utils/wheatCodeColors'
import { useCallback, useMemo } from 'react'
import {
  filtersCounterTextStyle,
  filtersHeaderStyle,
} from '../../DataAnalysisFiltersInfo.styled'

interface ProductsFilterProps {
  products: TBlend[]
  selectedProducts: string[]
  onProductsChange: (products: string[]) => void
}

export const ProductsFilter = ({
  products,
  selectedProducts,
  onProductsChange,
}: ProductsFilterProps) => {
  const colorMap = generateStaticColor(products)

  const options: TValues[] = products.map((product: TBlend) => ({
    id: Number(product.id),
    name: product.name,
    color: colorMap[product.id],
    checked: selectedProducts.includes(String(product.name)),
  }))

  const allSelected = useMemo(() => {
    return products.length > 0 && selectedProducts.length === products.length
  }, [products.length, selectedProducts.length])

  const handleSelectAll = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      if (event.target.checked) {
        const allProducts = products.map((p) => String(p.name))
        onProductsChange(allProducts)
      } else {
        onProductsChange([])
      }
    },
    [products, onProductsChange]
  )

  return (
    <Box>
      <Stack sx={filtersHeaderStyle}>
        <Tooltip title={allSelected ? 'Deselect all' : 'Select all'}>
          <Checkbox
            checked={allSelected}
            onChange={handleSelectAll}
            size="small"
          />
        </Tooltip>
        <Typography>
          Products
          {selectedProducts.length ? (
            <Typography sx={filtersCounterTextStyle}>
              ({selectedProducts.length})
            </Typography>
          ) : (
            ''
          )}
        </Typography>
      </Stack>
      <ColoredMultySelect
        valuesList={options}
        mode={FILTERS_MODE.LIST}
        handleListChange={onProductsChange}
        isSquare={true}
      />
    </Box>
  )
}
